import React from 'react';
import ServicesEditTemplate from './services-edit-template'

const CitizenshipService = () => {
    return <ServicesEditTemplate doc="citizenship" service="Citizenship" />;
};

export default CitizenshipService;